module.exports = __webpack_public_path__ + "img/ZB_typography.eaaf596d.webp";